import { useQuery } from "@tanstack/react-query";
import { useApi } from "hooks/useApi";

export const useBisacCatalogueQuery = () => {
  const api = useApi();

  return useQuery({
    queryKey: ["bisac", "codes"],
    queryFn: () => api.bisac.getCodes(),
    staleTime: Infinity,
  });
};
